import defaultReducer from "./defaultReducer";

export default defaultReducer("SITE_VARIANCE_HISTORY_MODAL", { open: false });
